import React from 'react';
import styles from './Header.module.css';
import logoIcon from '../../assets/main_logo-icon.svg';
import profileBtnIcon from '../../assets/profile_btn-icon.svg';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const Header = ({inProfile}) => {
	const {first_name} = useSelector(state => state.user.user)

	return (
			<header className={styles.main}>
				<img src={logoIcon} alt="logoIcon" />
			<Link to={'/profile'} className={styles.link} style={inProfile ? { backgroundColor: '#0050EF'} : {}}>
					<img src={profileBtnIcon} alt="profileBtnIcon" />
				<p>{first_name}</p>
				</Link>
			</header>
	);
};
